import React from 'react'
import { Document } from '@contentful/rich-text-types'
import { TextBlock } from '@/components/common'
import BannerImage from '../BannerImage'
import CaseStudy from '../CaseStudy'
import Community from '../Community'
import Funding from '../Funding'
import Hero from '../Hero'
import Pricing from '../Pricing'
import Process from '../Process'
import { Step, Image, Video, ContentBlock, CTABlock } from '../types'

export interface Props {
  content: {
    heading: string
    subheading: string
    video: Video
    process: Step[]
    formUrl: string
    bannerImage?: Image
    communityImage: Image
    community: ContentBlock[]
    funding: ContentBlock
    pricing: ContentBlock[]
    caseStudies: CTABlock[]
    disclaimer: Document
  }
}

const ApplyPage: React.FC<Props> = ({ content }) => {
  const {
    heading,
    subheading,
    video,
    process,
    formUrl,
    bannerImage,
    communityImage,
    community,
    funding,
    pricing,
    caseStudies,
    disclaimer,
  } = content

  return (
    <>
      <Hero
        heading={heading}
        subheading={subheading}
        video={video}
        className="mb-8 lg:mb-12 xl:mb-24"
      />

      <Process
        title="Easy Process"
        steps={process}
        formUrl={formUrl}
        className="mb-8 lg:mb-12 xl:mb-24"
      />

      {bannerImage && (
        <BannerImage image={bannerImage} className="mb-8 lg:mb-12 xl:mb-24" />
      )}

      <Community
        image={communityImage}
        items={community}
        className="mb-8 lg:mb-12 xl:mb-24"
      />

      <Funding {...funding} formUrl={formUrl} className="-mb-24" />

      <Pricing
        title={pricing[0].title}
        text={pricing[0].text}
        items={pricing.slice(1)}
        formUrl={formUrl}
        className="bg-core-gray-100 pb-8 pt-36 lg:pb-12 lg:pt-48 xl:pb-24"
      />

      <div className="bg-core-gray-100">
        <div className="2xl:px-8 mx-auto max-w-[1536px]">
          {caseStudies.map((item) => (
            <CaseStudy
              key={item.id}
              {...item}
              className="2xl:mb-16 2xl:rounded-lg last:2xl:mb-0 flex flex-col-reverse overflow-hidden bg-white md:flex-row even:md:flex-row-reverse"
            />
          ))}
        </div>
      </div>

      <div className="bg-core-gray-100 pb-6 pt-8 md:pt-12">
        <div className="mx-auto max-w-[1360px] px-6 md:px-8">
          <TextBlock document={disclaimer} />
        </div>
      </div>
    </>
  )
}

export default ApplyPage
